<template>
    <div>
      <h3 data-aos="fade-left" >{{ $t('ac_cleaning.more_info_section.title') }}</h3>
      <p data-aos="fade-right" class="sub-text" v-html="$t('ac_cleaning.more_info_section.subtitle')"></p>
      <p>{{ description2 }}</p>
    </div>
  </template>
  
  <script>
  export default {
    data () {
      return {
        title: 'เราให้มากกว่าแค่ "การล้าง"',
        description: `BeNeat ตั้งใจให้บริการแบบใส่ใจ ไม่เร่งรีบ และเก็บรายละเอียดทุกมุม แอร์สะอาด ไม่ใช่แค่เรื่องความเย็น แต่คือสุขภาพที่ดีของทั้งครอบครัว BeNeat มุ่งมั่นให้บริการที่ปลอดภัย ใส่ใจทุกรายละเอียด และสร้างมาตรฐานใหม่ให้กับบริการล้างแอร์`,
        description2: 'เพราะเรารู้ว่า…แอร์สะอาด = อากาศดีในบ้าน = สุขภาพดีของทุกคนในครอบครัว 💙'
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  @import '../../../static/sass/page/ac_cleaning.scss';

  </style>
  


// WEBPACK FOOTER //
// src/components/acCleaningRe/MoreThanCleaning.vue